export const apiConstants = {
  CHANNEL: 'web',
  V: '2',
  VER: '3.8.2',
  // STR_VER: '3.8.2',
  STR_VER: '3.8.2',
  /** 区分app和智门户 */
  STR_OS: '99',
  SOURCE_TYPE: 7,
  STR_OS_DATA: '33', // 大数据的os
  VER_DATA: '4.1.8',
  API_PREFIX: '/learn/app',
  /** 渠道上报 智门户固定为3 */
  TERMINAL_CHANNEL: 3,
  trainClassInfoVer: '7.2.2'
}

export enum LoginBodyCodeEnum {
  /** 验证通过 */
  VALID = '1',
  /** 无企业身份或账户、密码验证不通过 */
  NO_IDENTITY_OR_NOT_VALID = '3',
  /** 验证码错误 */
  VERIFICATION_CODE_ERROR = '4',
  /** 登录成功，但无身份匹配信息 */
  VALID_WITH_NOT_IDENTITY = '5',
  /** 多身份 */
  MULTI_IDENTITY = '6',
  /** 冻结账户 */
  FROZEN_ACCOUNT = '12',
  /** 未绑定手机号 */
  NO_BINDING_PHONE = '10',
  /** 图形验证码错误 */
  SLIDE_CAPTCHA_ERR = '100',
  /** 只有云校企业身份，提示没有权限 */
  NO_PERMISSION = '1200003',
  /** 用户已经在PC直播端登录 */
  ACCOUNT_LOGIN_ANOTHER = '17'
}

export const generalApiPrefix = '/learn/app/clientapi'
const stg1UploadUrl = `//hrmsv3-zn-platform-inner-proxy-stg1.paic.com.cn${generalApiPrefix}`
const prdUploadUrl = `//hrmsv3-zn-platform-inner-proxy-prd.paic.com.cn${generalApiPrefix}`

export const getUploadUrl = () => {
  const origin = window.location.origin
  if (origin.indexOf('stg1') > -1 || origin.indexOf('stg5') > -1) {
    return stg1UploadUrl
  }
  return prdUploadUrl
}

export const uploadApiUrl =
  process.env.NODE_ENV === 'development' ? stg1UploadUrl : getUploadUrl()
